var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loyout"}},[_c('el-container',[_c('layoutAside'),_vm._v(" "),_c('el-container',[_c('layoutHeader'),_vm._v(" "),_c('el-main',{attrs:{"id":"elmain"}},[_c('transition',{attrs:{"name":"main","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('el-footer',{attrs:{"id":"footer"}},[_c('Bottom')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6067374c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/system/index/layout/layout.vue
// module id = null
// module chunks = 